import { type RefObject, useEffect, useState } from 'react';

/** Запас до области видимости: данные начинают грузиться заранее, пока блок ещё не на экране */
const ROOT_MARGIN = '400px 0px';

/**
 * Блок подошёл к области видимости — однократно. Аналог `LazyLoad` из `@cian/components` монолита:
 * объявления на проде запрашиваются, только когда пользователь доскроллил до блока
 */
export function useIsNearViewport(ref: RefObject<Element | null>): boolean {
  const [isNear, setIsNear] = useState(false);

  useEffect(() => {
    const node = ref.current;

    if (isNear || !node) {
      return;
    }

    const observer = new IntersectionObserver(
      entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          setIsNear(true);
        }
      },
      { rootMargin: ROOT_MARGIN },
    );

    observer.observe(node);

    return () => observer.disconnect();
  }, [ref, isNear]);

  return isNear;
}
